<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        class="screenInput"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.company_id"
        placeholder="请选择企业"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in companyList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.user_id"
        placeholder="请选择下单用户"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in userList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.status"
        placeholder="请选择预约状态"
      >
        <el-option label="全部预约状态" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-date-picker
        class="screenInput"
        v-model="screen.date"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择预约日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="场地" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.place ? scope.row.place.title : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约人" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约人手机号" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.phone : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约日期" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.start_time }}</span>
        </template>
      </el-table-column>

      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.end_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约状态" width="110" align="center">
        <template slot-scope="scope">
          <!-- <el-tag
            :type="
              scope.row.status == '1'
                ? 'success'
                : scope.row.status == '0'
                ? 'info'
                : 'danger'
            "
            disable-transitions
            ></el-tag
          > -->
          {{
            scope.row.status == 1
              ? "待审核"
              : scope.row.status == 2
              ? "已预约"
              : scope.row.status == 3
              ? "已取消"
              : scope.row.status == 4
              ? "已结束"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="getInfo(scope.row.id)"
            v-if="roles.includes('/place/farm_apply_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="operation(scope.row.id, 2)"
            v-if="
              roles.includes('/place/farm_apply_operation') &&
              scope.row.status == 1
            "
            >通过</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="operation(scope.row.id, 3)"
            v-if="
              roles.includes('/place/farm_apply_operation') &&
              (scope.row.status == 1||scope.row.status == 2)
            "
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>

    <el-drawer size="700px" title="查看" :visible.sync="drawer" direction="rtl">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="企业">
          <el-select filterable v-model="ruleForm.company_id" disabled>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <div v-if="ruleForm.user">
          <el-form-item label="预约人姓名">
            <el-input v-model="ruleForm.user.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="预约人手机号">
            <el-input
              maxlength="11"
              v-model="ruleForm.user.phone"
              disabled
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="服务状态">
          <el-select disabled v-model="ruleForm.status">
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="已预约" :value="2"></el-option>
            <el-option label="已取消" :value="3"></el-option>
            <el-option label="已结束" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm.status == 3">
          <el-form-item label="取消人类型">
            <el-select
              disabled
              filterable
              class="screenInput"
              v-model="ruleForm.cancel_user_type"
              placeholder="请选择取消人类型"
            >
              <el-option label="后台" :value="1"></el-option>
              <el-option label="下单本人" :value="2"></el-option>
              <el-option label="APP" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            label="后台取消人"
            v-if="ruleForm.cancel_user_type == 1"
          >
            <el-select
              filterable
              class="screenInput"
              v-model="ruleForm.system_admin_id"
              placeholder="请选择后台取消人员"
            >
              <el-option
                :label="item.username"
                :value="item.id"
                v-for="(item, index) in adminUserList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="取消时间">
            <el-date-picker
              disabled
              v-model="ruleForm.cancel_time"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-if="ruleForm.place">
          <el-form-item label="场地标题" prop="title">
            <el-input
              disabled
              v-model="ruleForm.place.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="租金价格" prop="price">
            <el-input
              disabled
              v-model="ruleForm.place.money"
              placeholder="请输入租金单价"
              ><template slot="append">元/h</template></el-input
            >
          </el-form-item>
          <el-form-item label="场地标签">
            <el-input disabled v-model="ruleForm.place.devices"></el-input>
          </el-form-item>
          <el-form-item label="场地图片">
            <el-image
              v-for="(img, ind) in ruleForm.place.thumb"
              :key="ind"
              style="width: 120px; height: 40px; margin: 0 5px 5px 0"
              :src="imageOss + img"
              fit="contain"
              :preview-src-list="$pathDispose(ruleForm.place.thumb)"
            >
            </el-image>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <!-- <el-dialog
      title="审批"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审核"
          prop="status"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="reason" label="驳回意见" v-if="form.status == 2">
          <el-input type="textarea" v-model="form.reason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, openCompany, openAgoUser } from "@/api/index";
import {
  venueApplyList,
  venueApplyOperation,
  venueApplyInfo,
} from "@/api/smartFarm";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      statusList: [
        {
          title: "待审核",
          id: 1,
        },
        {
          title: "已预约",
          id: 2,
        },
        {
          title: "已取消",
          id: 3,
        },
        {
          title: "已结束",
          id: 4,
        },
      ],
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        user_id: "",
        company_id: "",
        status: "",
        date: "",
        object: "place,park,user",
      },
      total: 0,
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      dialogVisible: false,
      form: {
        id: "",
        status: "",
        reason: "",
      },
      rules: {
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      companyList: [],
      userList: [],
      drawer: false,
      ruleForm: {},
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.getCompany();
    this.getUser();
    this.fetchData();
    this.getPark();
  },
  methods: {
    operation(id, val) {
      var that = this;
      let title = "";
      if (val == 2) {
        title = "确定预约？";
      } else if (val == 3) {
        title = "确定取消？";
      }
      this.$confirm(title)
        .then(() => {
          venueApplyOperation({ id: id, operation: val }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 查看详情
    getInfo(id) {
      var that = this;
      venueApplyInfo({ id: id }).then((res) => {
        that.ruleForm = res.data.info;
        that.drawer = true;
      });
    },
    // 获取用户列表
    getUser() {
      openAgoUser({is_youke:2}).then((response) => {
        this.userList = response.data.lists.data;
      });
    },
    // 获取企业
    getCompany(park_id = "") {
      openCompany({ is_page: 2, park_id: park_id }).then((response) => {
        this.companyList = response.data.lists;
      });
    },
    reset() {
      this.screen = {
        park_id: "",
        page: 1,
        page_size: 15,
        user_id: "",
        company_id: "",
        status: "",
        date: "",
        object: "place,park,user",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      venueApplyList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
</style>
